(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-category-content-coloured-fine-jewlery"] && !Shopify.designMode) return;
  try {
    let isDynamicContentLoading = false;
let isDynamicContentInitialized = false;

async function loadDynamicRingsContent() {
  try {
    const assetInput = document.getElementById("dynamic-asseturl");

    if (!assetInput || !assetInput.value) {
      console.error("Dynamic asset URL missing");
      return;
    }

    const dynamicAssetUrl = assetInput.value;


    if (isDynamicContentLoading) return;
    isDynamicContentLoading = true;

    const container = document.getElementById(
      'dynamic-category-content-fine-jewlery'
    );

    if (!container) {
      isDynamicContentLoading = false;
      return;
    }

    const response = await fetch(dynamicAssetUrl);

    const data = await response.json();

    const rings = [
      'diamond-pendant',
      'diamond-tennis-bracelet',
      'diamond-earrings',
      'womens-wedding-bands',
      'mens-wedding-bands',
    ];

    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];

    const isRing = rings.includes(handle);
    const content = data[handle];

    if (!content || !isRing) {
      container.style.display = 'none';
      isDynamicContentLoading = false;
      return;
    }

    container.style.display = 'block';

    // Text replace
    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);
    const handle2Text = handle;

    document
      .querySelectorAll('#dynamic-handle-1')
      .forEach((el) => (el.innerText = handle1Text));

    document
      .querySelectorAll('#dynamic-handle-2')
      .forEach((el) => (el.innerText = handle2Text));

    document.getElementById('cat-title').innerHTML = content.title;
    document.getElementById('cat-intro').innerHTML = content.description;

    const faqHTML = `
      <div class="faq-container">
        <h3 class="h2 text-center my-5">Frequently Asked Questions</h3>
        ${content.faqs
          .map(
            (f, i) => `
            <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
              <h5 class="h5 faq-question">
                ${f.q}
                <span class="faq-icon"><i class="icon-plus"></i></span>
              </h5>
              <p class="faq-answer">${f.a}</p>
            </div>
          `
          )
          .join('')}
      </div>
    `;

    document.getElementById('dynamic-faq-block').innerHTML = faqHTML;

    // keep the FAQ structured data in step with what was just rendered
    if (window.rouFaqSchema) window.rouFaqSchema.publish(content.faqs);

    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const icon = item.querySelector('.faq-icon');

        answer.classList.toggle('active');

        icon.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  } catch (err) {
    console.error('Error loading dynamic content:', err);
  } finally {
    isDynamicContentLoading = false;
  }
}

document.addEventListener('DOMContentLoaded', loadDynamicRingsContent);


// ✅ Shopify Theme Editor Safe Init
if (!isDynamicContentInitialized) {
  isDynamicContentInitialized = true;

  // ❌ Disable history watcher inside theme editor
  const isThemeEditor =
    window.Shopify && window.Shopify.designMode === true;

  if (!isThemeEditor) {
    (function () {
      const pushState = history.pushState;
      history.pushState = function () {
        pushState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      const replaceState = history.replaceState;
      history.replaceState = function () {
        replaceState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('urlChange'));
      });
    })();

    window.addEventListener('urlChange', loadDynamicRingsContent);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-coloured-lab-color"] && !Shopify.designMode) return;
  try {
    let isLabDynamicContentLoading = false;
let isLabDynamicContentInitialized = false;

async function loadDynamicLabContent() {
  try {
    const assetInput = document.getElementById("dynamic-asseturl");

    if (!assetInput || !assetInput.value) {
      console.error("Dynamic asset URL missing");
      return;
    }

    const dynamicAssetUrl = assetInput.value;
    if (isLabDynamicContentLoading) return;
    isLabDynamicContentLoading = true;

    const container = document.getElementById(
      'dynamic-category-content-lab-color'
    );

    if (!container) {
      isLabDynamicContentLoading = false;
      return;
    }

    const response = await fetch(dynamicAssetUrl);

    const data = await response.json();

    const rings = [
      'round',
      'oval',
      'pear',
      'princess',
      'asscher',
      'heart',
      'emerald',
      'radiant',
      'cushion',
      'marquise',
      'coloured-lab-grown-diamonds',
    ];

    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handle1 = path[path.length - 2] || '';

    const tempHandles = [handle, handle1];

    if (!tempHandles.includes('coloured-lab-grown-diamonds')) {
      isLabDynamicContentLoading = false;
      return;
    }

    const isRing = rings.includes(handle);
    const newHandle = `${handle}-coloured-lab-grown-diamonds`;
    const content = data[newHandle];

    const stylesBlock = document.getElementById('dynamic-styles-content');

    if (!content || !isRing) {
      container.style.display = 'none';
      isLabDynamicContentLoading = false;
      return;
    }

    container.style.display = 'block';

    if (stylesBlock) {
      if (handle !== 'coloured-lab-grown-diamonds') {
        stylesBlock.style.display = 'block';
      } else {
        stylesBlock.style.display = 'none';
      }
    }

    // Handle Text Replace
    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);
    const handle2Text = handle;

    document
      .querySelectorAll('#dynamic-handle-1')
      .forEach((el) => (el.innerText = handle1Text));

    document
      .querySelectorAll('#dynamic-handle-2')
      .forEach((el) => (el.innerText = handle2Text));

    const titleEl = document.getElementById('cat-title');
    const introEl = document.getElementById('cat-intro');
    const faqBlock = document.getElementById('dynamic-faq-block');

    if (titleEl) titleEl.innerHTML = content.title;
    if (introEl) introEl.innerHTML = content.description;

    if (faqBlock) {
      const faqHTML = `
        <div class="faq-container">
          <h3 class="h2 text-center my-5">Frequently Asked Questions</h3>
          ${content.faqs
            .map(
              (f, i) => `
              <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
                <h5 class="h5 faq-question">
                  ${f.q}
                  <span class="faq-icon"><i class="icon-plus"></i></span>
                </h5>
                <p class="faq-answer">${f.a}</p>
              </div>
            `
            )
            .join('')}
        </div>
      `;

      faqBlock.innerHTML = faqHTML;

      // keep the FAQ structured data in step with what was just rendered
      if (window.rouFaqSchema) window.rouFaqSchema.publish(content.faqs);

      faqBlock.querySelectorAll('.faq-question').forEach((item) => {
        item.addEventListener('click', () => {
          const answer = item.nextElementSibling;
          const icon = item.querySelector('.faq-icon');

          if (!answer || !icon) return;

          answer.classList.toggle('active');

          icon.innerHTML = answer.classList.contains('active')
            ? `<i class="icon-minus"></i>`
            : `<i class="icon-plus"></i>`;
        });
      });
    }
  } catch (err) {
    console.error('Error loading lab dynamic content:', err);
  } finally {
    isLabDynamicContentLoading = false;
  }
}


// Initial Load
document.addEventListener('DOMContentLoaded', loadDynamicLabContent);


// Shopify Safe Init
if (!isLabDynamicContentInitialized) {
  isLabDynamicContentInitialized = true;

  const isThemeEditor =
    window.Shopify && window.Shopify.designMode === true;

  if (!isThemeEditor) {
    (function () {
      const pushState = history.pushState;
      history.pushState = function () {
        pushState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      const replaceState = history.replaceState;
      history.replaceState = function () {
        replaceState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('urlChange'));
      });
    })();

    window.addEventListener('urlChange', loadDynamicLabContent);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-diamonds"] && !Shopify.designMode) return;
  try {
    (function () {
  var CONTAINER_ID = 'dynamic-category-content-diamonds';
  var SCHEMA_ID = 'rou-faq-schema';

  // Diamond types that share this page, in the order the tabs use them.
  var TYPES = [
    'natural-diamonds',
    'lab-diamonds',
    'coloured-lab-grown-diamonds'
  ];

  // Shape sub-pages, e.g. /lab-diamonds/oval.
  var SHAPES = [
    'round',
    'oval',
    'pear',
    'princess',
    'asscher',
    'heart',
    'emerald',
    'radiant',
    'cushion',
    'marquise'
  ];

  // Carat landing pages, e.g. /natural-diamonds/0-30-carat-diamond. These have
  // no authored copy in the category JSON — carat is a continuous value, not a
  // fixed list like shapes — so their FAQ is built from a template instead.
  var CARAT_SLUG = /-carat-diamond$/i;

  var TYPE_LABELS = {
    'natural-diamonds': { singular: 'Natural Diamond', plural: 'Natural Diamonds' },
    'lab-diamonds': { singular: 'Lab Grown Diamond', plural: 'Lab Grown Diamonds' },
    'coloured-lab-grown-diamonds': { singular: 'Lab Grown Colour Diamond', plural: 'Lab Grown Colour Diamonds' }
  };

  var requests = {};
  var latest = 0;

  // "0-30-carat-diamond" -> "0.30", "2-carat-diamond" -> "2". Mirrors the
  // parsing in layout/theme.liquid that builds the carat page's meta title.
  function parseCaratFromSlug(slug) {
    var caratPart = slug.replace(CARAT_SLUG, '');
    var parts = caratPart.split('-').filter(Boolean);

    if (parts.length === 1) return parts[0];
    if (parts.length >= 2) return parts[0] + '.' + parts[1];
    return '';
  }

  function buildCaratContent(type, carat) {
    var labels = TYPE_LABELS[type] || { singular: 'Diamond', plural: 'Diamonds' };
    var singularLower = labels.singular.toLowerCase();

    return {
      title: '',
      description: '',
      faqs: [
        {
          q: 'Is ' + carat + 'ct A Good Size For A ' + labels.singular + ' Ring?',
          a: 'Yes, it offers noticeable sparkle while remaining budget-friendly.'
        },
        {
          q: 'What Shapes Are Best For ' + carat + ' Carat ' + labels.singular + '?',
          a: 'Round, princess, and oval shapes are popular choices for ' + carat + 'ct ' + singularLower + '.'
        },
        {
          q: 'Can I Buy A ' + carat + ' Carat ' + labels.singular + ' Ring Online In UK?',
          a: 'Absolutely. Rings of UK provides secure and insured delivery across the UK.'
        }
      ]
    };
  }

  function assetUrl(type) {
    var input = document.getElementById('dynamic-asseturl');
    return input ? input.getAttribute('data-' + type) : '';
  }

  // Which type and which entry the current URL asks for, or null when this
  // page shows no category copy at all.
  function currentRoute() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    var last = parts[parts.length - 1] || '';
    var previous = parts[parts.length - 2] || '';

    var type = '';
    if (TYPES.indexOf(last) > -1) {
      type = last;
    } else if (TYPES.indexOf(previous) > -1) {
      type = previous;
    }

    if (!type) return null;

    if (last === type) {
      return { type: type, key: type + '-' + type };
    }

    if (SHAPES.indexOf(last) > -1) {
      return { type: type, key: last + '-' + type };
    }

    if (CARAT_SLUG.test(last)) {
      var carat = parseCaratFromSlug(last);
      if (carat) return { type: type, carat: carat };
    }

    return null;
  }

  function load(url) {
    if (!requests[url]) {
      requests[url] = fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .catch(function (error) {
          delete requests[url];
          throw error;
        });
    }

    return requests[url];
  }

  function plainText(value) {
    var holder = document.createElement('div');
    holder.innerHTML = value == null ? '' : String(value);
    return (holder.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Keep the FAQPage JSON-LD on the questions that are now on screen. The tag
  // is printed by seo-jsonld.liquid for the type the page was served for, so
  // without this it would still describe the tab the visitor arrived on.
  function syncSchema(faqs) {
    var entities = [];

    faqs.forEach(function (faq) {
      var name = plainText(faq.q);
      var answer = plainText(faq.a);
      if (!name || !answer) return;

      entities.push({
        '@type': 'Question',
        name: name,
        acceptedAnswer: { '@type': 'Answer', text: answer }
      });
    });

    if (!entities.length) return;

    var tag = document.getElementById(SCHEMA_ID);
    if (!tag) {
      tag = document.createElement('script');
      tag.type = 'application/ld+json';
      tag.id = SCHEMA_ID;
      document.head.appendChild(tag);
    }

    var pageUrl = window.location.origin + window.location.pathname;

    tag.textContent = JSON.stringify(
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        '@id': pageUrl + '#faq',
        url: pageUrl,
        mainEntity: entities
      },
      null,
      2
    );
  }

  function paintFaqs(faqBlock, faqs) {
    faqBlock.innerHTML =
      '<div class="faq-container">' +
      '<h3 class="h2 text-center my-5">Frequently Asked Questions</h3>' +
      faqs
        .map(function (faq, index) {
          return (
            '<div class="faq-item ' + (index === 0 ? 'faq-item-1' : '') + '">' +
            '<h5 class="h5 faq-question">' +
            faq.q +
            '<span class="faq-icon"><i class="icon-plus"></i></span>' +
            '</h5>' +
            '<p class="faq-answer">' + faq.a + '</p>' +
            '</div>'
          );
        })
        .join('') +
      '</div>';

    faqBlock.querySelectorAll('.faq-question').forEach(function (item) {
      item.addEventListener('click', function () {
        var answer = item.nextElementSibling;
        var icon = item.querySelector('.faq-icon');

        if (!answer || !icon) return;

        answer.classList.toggle('active');

        icon.innerHTML = answer.classList.contains('active')
          ? '<i class="icon-minus"></i>'
          : '<i class="icon-plus"></i>';
      });
    });
  }

  function paint(container, content) {
    var titleEl = document.getElementById('cat-title');
    var introEl = document.getElementById('cat-intro');
    var faqBlock = document.getElementById('dynamic-faq-block');

    if (titleEl) titleEl.innerHTML = content.title || '';
    if (introEl) introEl.innerHTML = content.description || '';

    if (faqBlock && Array.isArray(content.faqs) && content.faqs.length) {
      paintFaqs(faqBlock, content.faqs);
      syncSchema(content.faqs);
    } else if (faqBlock) {
      faqBlock.innerHTML = '';
    }

    container.style.display = 'block';
  }

  function renderCurrent() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    // Every URL change starts a new request; an earlier one that lands after
    // this one must not paint the tab the visitor has already left.
    var token = ++latest;
    var route = currentRoute();

    if (!route) {
      container.style.display = 'none';
      return;
    }

    if (route.carat) {
      paint(container, buildCaratContent(route.type, route.carat));
      return;
    }

    var url = assetUrl(route.type);
    if (!url) {
      container.style.display = 'none';
      return;
    }

    load(url)
      .then(function (data) {
        if (token !== latest) return;

        var content = data ? data[route.key] : null;

        if (!content) {
          container.style.display = 'none';
          return;
        }

        paint(container, content);
      })
      .catch(function (error) {
        if (token !== latest) return;
        console.error('Error loading diamond category content:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCurrent);
  } else {
    renderCurrent();
  }

  window.addEventListener('urlChange', renderCurrent);

  // The tabs navigate with the History API, so the urlChange event has to be
  // raised from it. The older per-type snippets patch history the same way, so
  // the patch is installed once. The theme editor reloads sections itself and
  // is left alone.
  var isThemeEditor = window.Shopify && window.Shopify.designMode === true;

  if (!isThemeEditor && !window.rouHistoryWatch) {
    window.rouHistoryWatch = true;

    var pushState = history.pushState;
    history.pushState = function () {
      pushState.apply(history, arguments);
      window.dispatchEvent(new Event('urlChange'));
    };

    var replaceState = history.replaceState;
    history.replaceState = function () {
      replaceState.apply(history, arguments);
      window.dispatchEvent(new Event('urlChange'));
    };

    window.addEventListener('popstate', function () {
      window.dispatchEvent(new Event('urlChange'));
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-engagement-rings"] && !Shopify.designMode) return;
  try {
    let isRingDynamicContentLoading = false;
let isRingDynamicContentInitialized = false;

async function loadDynamicRingContent() {
try {
const assetInput = document.getElementById("dynamic-asseturl");

if (!assetInput || !assetInput.value) {
console.error("Dynamic asset URL missing");
return;
}

const dynamicAssetUrl = assetInput.value;
if (isRingDynamicContentLoading) return;
isRingDynamicContentLoading = true;

const container = document.getElementById(
'dynamic-category-content-ring'
);

if (!container) {
isRingDynamicContentLoading = false;
return;
}

const response = await fetch(dynamicAssetUrl);

const data = await response.json();

const rings = [
'solitaire',
'halo',
'bezel',
'hidden-halo',
'pave',
'side-stone',
'three-stone',
'nature-inspired',
'vintage',
'toi-et-moi',
'unique',
'engagement-rings',
];

const path = window.location.pathname.split('/').filter(Boolean);
const handle = path[path.length - 1];
const handle1 = path[path.length - 2] || '';

const tempHandles = [handle, handle1];

if (!tempHandles.includes('engagement-rings')) {
isRingDynamicContentLoading = false;
return;
}

const isRing = rings.includes(handle);
const newHandle = `${handle}-engagement-rings`;
const content = data[newHandle];

const stylesBlock = document.getElementById('dynamic-styles-content');

if (!content || !isRing) {
container.style.display = 'none';
isRingDynamicContentLoading = false;
return;
}

container.style.display = 'block';

if (stylesBlock) {
if (handle !== 'engagement-rings') {
stylesBlock.style.display = 'block';
} else {
stylesBlock.style.display = 'none';
}
}

// Dynamic Handle Text
const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);
const handle2Text = handle;

document
.querySelectorAll('#dynamic-handle-1')
.forEach((el) => (el.innerText = handle1Text));

document
.querySelectorAll('#dynamic-handle-2')
.forEach((el) => (el.innerText = handle2Text));

const sectionsEl = document.getElementById('cat-sections');
const faqBlock = document.getElementById('dynamic-faq-block');

if (sectionsEl) {
if (Array.isArray(content.sections) && content.sections.length > 0) {
sectionsEl.innerHTML = content.sections
.map(s => `
${s.title ? `<h2 class="h4">${s.title}</h2>` : ''}
${s.description ? `<p>${s.description}</p>` : ''}
`)
.join('');
} else {
let html = '';

// 1. Base title + description
if (content.title) {
html += `<h2 class="h4">${content.title}</h2>`;
}

if (content.description) {
html += `<p>${content.description}</p>`;
}

// 2. Loop through title1 → titleX
let i = 1;
const MAX_SECTIONS = 20; // safety cap

while (i <= MAX_SECTIONS) { const titleKey=`title${i}`; const descKey=`description${i}`; // stop when BOTH are missing
  if (!content[titleKey] && !content[descKey]) { break; } if (content[titleKey]) { html +=`<h2 class="h4">
  ${content[titleKey]}</h2>`;
  }

  if (content[descKey]) {
  html += `<p>${content[descKey]}</p>`;
  }

  i++;
  }

  sectionsEl.innerHTML = html;
  }
  }

  if (faqBlock) {
  const faqHTML = `
  <div class="faq-container">
    <h3 class="h2 text-center my-5">Frequently Asked Questions</h3>
    ${content.faqs
    .map(
    (f, i) => `
    <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
      <h5 class="h5 faq-question">
        ${f.q}
        <span class="faq-icon"><i class="icon-plus"></i></span>
      </h5>
      <p class="faq-answer">${f.a}</p>
    </div>
    `
    )
    .join('')}
  </div>
  `;

  faqBlock.innerHTML = faqHTML;

  // keep the FAQ structured data in step with what was just rendered
  if (window.rouFaqSchema) window.rouFaqSchema.publish(content.faqs);

  faqBlock.querySelectorAll('.faq-question').forEach((item) => {
  item.addEventListener('click', () => {
  const answer = item.nextElementSibling;
  const icon = item.querySelector('.faq-icon');

  if (!answer || !icon) return;

  answer.classList.toggle('active');

  icon.innerHTML = answer.classList.contains('active')
  ? `<i class="icon-minus"></i>`
  : `<i class="icon-plus"></i>`;
  });
  });
  }
  } catch (err) {
  console.error('Error loading ring dynamic content:', err);
  } finally {
  isRingDynamicContentLoading = false;
  }
  }


  // Initial Load
  document.addEventListener('DOMContentLoaded', loadDynamicRingContent);


  // Shopify Safe Init
  if (!isRingDynamicContentInitialized) {
  isRingDynamicContentInitialized = true;

  const isThemeEditor =
  window.Shopify && window.Shopify.designMode === true;

  if (!isThemeEditor) {
  (function () {
  const pushState = history.pushState;
  history.pushState = function () {
  pushState.apply(history, arguments);
  window.dispatchEvent(new Event('urlChange'));
  };

  const replaceState = history.replaceState;
  history.replaceState = function () {
  replaceState.apply(history, arguments);
  window.dispatchEvent(new Event('urlChange'));
  };

  window.addEventListener('popstate', () => {
  window.dispatchEvent(new Event('urlChange'));
  });
  })();

  window.addEventListener('urlChange', loadDynamicRingContent);
  }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-lab-diamonds"] && !Shopify.designMode) return;
  try {
    let isLabDiamondDynamicLoading = false;
let isLabDiamondDynamicInitialized = false;

async function loadDynamicLabDiamondContent() {
  try {
    const assetInput = document.getElementById("dynamic-asseturl");

    if (!assetInput || !assetInput.value) {
      console.error("Dynamic asset URL missing");
      return;
    }

    const dynamicAssetUrl = assetInput.value;
    if (isLabDiamondDynamicLoading) return;
    isLabDiamondDynamicLoading = true;

    const container = document.getElementById(
      'dynamic-category-content-lab'
    );

    if (!container) {
      isLabDiamondDynamicLoading = false;
      return;
    }

    const response = await fetch(dynamicAssetUrl);

    const data = await response.json();

    const rings = [
      'round',
      'oval',
      'pear',
      'princess',
      'asscher',
      'heart',
      'emerald',
      'radiant',
      'cushion',
      'marquise',
      'lab-diamonds',
    ];

    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handle1 = path[path.length - 2] || '';

    const tempHandles = [handle, handle1];

    if (!tempHandles.includes('lab-diamonds')) {
      isLabDiamondDynamicLoading = false;
      return;
    }

    const isRing = rings.includes(handle);
    const newHandle = `${handle}-lab-diamonds`;
    const content = data[newHandle];

    const stylesBlock = document.getElementById('dynamic-styles-content');

    if (!content || !isRing) {
      container.style.display = 'none';
      isLabDiamondDynamicLoading = false;
      return;
    }

    container.style.display = 'block';

    if (stylesBlock) {
      if (handle !== 'lab-diamonds') {
        stylesBlock.style.display = 'block';
      } else {
        stylesBlock.style.display = 'none';
      }
    }

    // Handle Text
    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);
    const handle2Text = handle;

    document
      .querySelectorAll('#dynamic-handle-1')
      .forEach((el) => (el.innerText = handle1Text));

    document
      .querySelectorAll('#dynamic-handle-2')
      .forEach((el) => (el.innerText = handle2Text));

    const titleEl = document.getElementById('cat-title');
    const introEl = document.getElementById('cat-intro');
    const faqBlock = document.getElementById('dynamic-faq-block');

    if (titleEl) titleEl.innerHTML = content.title;
    if (introEl) introEl.innerHTML = content.description;

    if (faqBlock) {
      const faqHTML = `
        <div class="faq-container">
          <h3 class="h2 text-center my-5">Frequently Asked Questions</h3>
          ${content.faqs
            .map(
              (f, i) => `
              <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
                <h5 class="h5 faq-question">
                  ${f.q}
                  <span class="faq-icon"><i class="icon-plus"></i></span>
                </h5>
                <p class="faq-answer">${f.a}</p>
              </div>
            `
            )
            .join('')}
        </div>
      `;

      faqBlock.innerHTML = faqHTML;

      // keep the FAQ structured data in step with what was just rendered
      if (window.rouFaqSchema) window.rouFaqSchema.publish(content.faqs);

      faqBlock.querySelectorAll('.faq-question').forEach((item) => {
        item.addEventListener('click', () => {
          const answer = item.nextElementSibling;
          const icon = item.querySelector('.faq-icon');

          if (!answer || !icon) return;

          answer.classList.toggle('active');

          icon.innerHTML = answer.classList.contains('active')
            ? `<i class="icon-minus"></i>`
            : `<i class="icon-plus"></i>`;
        });
      });
    }
  } catch (err) {
    console.error('Error loading lab diamond dynamic content:', err);
  } finally {
    isLabDiamondDynamicLoading = false;
  }
}


// Initial Load
document.addEventListener('DOMContentLoaded', loadDynamicLabDiamondContent);


// Shopify Safe Init
if (!isLabDiamondDynamicInitialized) {
  isLabDiamondDynamicInitialized = true;

  const isThemeEditor =
    window.Shopify && window.Shopify.designMode === true;

  if (!isThemeEditor) {
    (function () {
      const pushState = history.pushState;
      history.pushState = function () {
        pushState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      const replaceState = history.replaceState;
      history.replaceState = function () {
        replaceState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('urlChange'));
      });
    })();

    window.addEventListener('urlChange', loadDynamicLabDiamondContent);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-category-content-natural-diamonds"] && !Shopify.designMode) return;
  try {
    let isNaturalDynamicLoading = false;
  let isNaturalDynamicInitialized = false;

async function loadDynamicNaturalContent() {
  try {
    const assetInput = document.getElementById("dynamic-asseturl");

    if (!assetInput || !assetInput.value) {
      console.error("Dynamic asset URL missing");
      return;
    }

    const dynamicAssetUrl = assetInput.value;
    if (isNaturalDynamicLoading) return;
    isNaturalDynamicLoading = true;

    const container = document.getElementById(
      'dynamic-category-content-natural'
    );

    if (!container) {
      isNaturalDynamicLoading = false;
      return;
    }

    const response = await fetch(dynamicAssetUrl);

    const data = await response.json();

    const rings = [
      'round',
      'oval',
      'pear',
      'princess',
      'asscher',
      'heart',
      'emerald',
      'radiant',
      'cushion',
      'marquise',
      'natural-diamonds',
    ];

    const path = window.location.pathname.split('/').filter(Boolean);
    const handle = path[path.length - 1];
    const handle1 = path[path.length - 2] || '';

    const tempHandles = [handle, handle1];

    if (!tempHandles.includes('natural-diamonds')) {
      isNaturalDynamicLoading = false;
      return;
    }

    const isRing = rings.includes(handle);
    const newHandle = `${handle}-natural-diamonds`;
    const content = data[newHandle];

    const stylesBlock = document.getElementById('dynamic-styles-content');

    if (!content || !isRing) {
      container.style.display = 'none';
      isNaturalDynamicLoading = false;
      return;
    }

    container.style.display = 'block';

    if (stylesBlock) {
      if (handle !== 'natural-diamonds') {
        stylesBlock.style.display = 'block';
      } else {
        stylesBlock.style.display = 'none';
      }
    }

    // Handle Text Replace
    const handle1Text = handle.charAt(0).toUpperCase() + handle.slice(1);
    const handle2Text = handle;

    document
      .querySelectorAll('#dynamic-handle-1')
      .forEach((el) => (el.innerText = handle1Text));

    document
      .querySelectorAll('#dynamic-handle-2')
      .forEach((el) => (el.innerText = handle2Text));

    const titleEl = document.getElementById('cat-title');
    const introEl = document.getElementById('cat-intro');
    const faqBlock = document.getElementById('dynamic-faq-block');

    if (titleEl) titleEl.innerHTML = content.title;
    if (introEl) introEl.innerHTML = content.description;

    if (faqBlock) {
      const faqHTML = `
        <div class="faq-container">
          <h3 class="h2 text-center my-5">Frequently Asked Questions</h3>
          ${content.faqs
            .map(
              (f, i) => `
              <div class="faq-item ${i === 0 ? 'faq-item-1' : ''}">
                <h5 class="h5 faq-question">
                  ${f.q}
                  <span class="faq-icon"><i class="icon-plus"></i></span>
                </h5>
                <p class="faq-answer">${f.a}</p>
              </div>
            `
            )
            .join('')}
        </div>
      `;

      faqBlock.innerHTML = faqHTML;

      // keep the FAQ structured data in step with what was just rendered
      if (window.rouFaqSchema) window.rouFaqSchema.publish(content.faqs);

      faqBlock.querySelectorAll('.faq-question').forEach((item) => {
        item.addEventListener('click', () => {
          const answer = item.nextElementSibling;
          const icon = item.querySelector('.faq-icon');

          if (!answer || !icon) return;

          answer.classList.toggle('active');

          icon.innerHTML = answer.classList.contains('active')
            ? `<i class="icon-minus"></i>`
            : `<i class="icon-plus"></i>`;
        });
      });
    }
  } catch (err) {
    console.error('Error loading natural diamond dynamic content:', err);
  } finally {
    isNaturalDynamicLoading = false;
  }
}


// Initial Load
document.addEventListener('DOMContentLoaded', loadDynamicNaturalContent);


// Shopify Safe Init
if (!isNaturalDynamicInitialized) {
  isNaturalDynamicInitialized = true;

  const isThemeEditor =
    window.Shopify && window.Shopify.designMode === true;

  if (!isThemeEditor) {
    (function () {
      const pushState = history.pushState;
      history.pushState = function () {
        pushState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      const replaceState = history.replaceState;
      history.replaceState = function () {
        replaceState.apply(history, arguments);
        window.dispatchEvent(new Event('urlChange'));
      };

      window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('urlChange'));
      });
    })();

    window.addEventListener('urlChange', loadDynamicNaturalContent);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-bracelets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-earrings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-fine-jewellery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-pendants"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
